<template>
  <div>
    <breadcrumbs  :adventure="adventure" :adventureId="adventureId" :chapter="chapter" :chapterId="chapterId" :timelineLocation="timelineLocation" ></breadcrumbs>
    <section id="page-timeline" class="mdl-grid adv-content" style="background-color: white; margin-top:20px;">
      <div class="mdl-grid mdl-cell--12-col">
        <div class="mdl-cell--6-col mdl-cell--12-col-tablet" >
          <div id="timeline-view" class="mdl-cell--12-col">
            <div id="timeline-container" class="timeline-container">
              <div>
                <router-link :to="'/editor/'+adventureId+'/chapters/'+chapterId+'/timeline/'+getLocationParent()"><div class="delimiter-node">
                <i v-if="getLocationName()" class="material-icons" style="width: 14px, height: 14px; position: relative; vertical-align: middle; ">keyboard_arrow_left</i>
                      {{getLocationName() || 'START'}}</div></router-link>
                <div class="arrow-down delimiter"></div>
              </div>
              <div v-for="(group, groupKey) in eventGroupsForLocation(timelineLocation)">
                <div class="group-node event-drop-area collapsed" :name="group.key">
                  <div class="plus-button" @click="createEventAndGroup(group.key)">
                    +
                  </div>
                </div>
                <div class="group-node">
                  <div class="arrow-up"></div>
                  <div class="event-drop-area event-group-node" :name="group.key">
                    <div v-for="(event, eventKey) in group.events" :name="event.key" :class="selectionClass(event.key, selectedEventId) + ' event-node'">
                      <i v-if="event.type==='group'" class="material-icons" style="width: 14px, height: 14px; position: relative; vertical-align: middle; margin-top: -3px; ">device_hub</i>
                      {{event.name||'untitled'}}</div>
                    <div class=" plus-button" @click="createEvent(group.key)">+</div>
                  </div>
                  <div class="arrow-down"></div>
                </div>
              </div>
              <div class="group-node event-drop-area collapsed">
                <div class="plus-button" @click="createEventAndGroup">
                  +
                </div>
              </div>  
              <div>
                <div class="arrow-up delimiter"></div>
                <div class="delimiter-node">END</div>
              </div>
            </div>
        </div>
      </div>
      <div class="mdl-cell--6-col mdl-cell--12-col-tablet" >
        <div  style="background-color: white; padding-left: 30px; text-align: left;" > 
          <h5 class="mdl-cell--12-col">Edit Event</h5>
          <div v-show="selectedEventId">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col" :class="{'is-dirty': selectedEvent.name}" > <!--  -->
              <input class="mdl-textfield__input" type="text" id="sample1" :value="selectedEvent.name" @input="changeEventName"> <!--:value="selectedObject.name" @input='updateName' -->
              <label class="mdl-textfield__label" for="sample1">Event Name...</label>
            </div>
            <div class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col">
              <select class="mdl-selectfield__select" id="eventType" name="eventType" @change="changeEventType"> 
                <option value="action" :selected="selectedEvent.type==='action'">Action</option>
                <option value="group" :selected="selectedEvent.type==='group'">Group</option>
              </select>
              <label class="mdl-selectfield__label" for="eventTypeLbl">Event Type</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
            <label :class="((selectedEvent.customText ? 'is-checked ' : '' ) + ' mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect ')" for="checkbox-1">
              <input style="opacity:0;" type="checkbox" id="checkbox-1" class="mdl-checkbox__input" :checked="selectedEvent.customText"  :value="selectedEvent.customText" @change="changeEventCustomText">
              <span class="mdl-checkbox__label">Custom Text</span>
            </label>
            <div v-if="selectedEvent.type==='action' && selectedEvent.customText" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col" :class="{'is-dirty': selectedEvent.text}" >
              <input class="mdl-textfield__input" type="text" id="sample1" :value="selectedEvent.text" @input="changeEventText"> <!--:value="selectedObject.name" @input='updateName' -->
              <label class="mdl-textfield__label" for="sample1">Custom text on success...</label>
            </div>
            <div v-if="selectedEvent.type==='action' && !selectedEvent.customText " class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col" :class="{'is-dirty': selectedEvent.text}" >
              <label class="mdl-label" style="font-style: italic; color: #999;" for="sample1">{{getActionText()||'No Text'}}</label>
            </div>
            <div v-if="selectedEvent.type==='action'" class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--6-col">
              <select :class="{'is-none':selectedEvent.baseObj===''}" class="mdl-selectfield__select" id="objectType" name="objectType" @change="changeBaseObj">
                <option v-for="(object, objectKey) in getObjects" :class="{'is-none':objectKey===''}" :value="objectKey" :selected="selectedEvent.baseObj===objectKey">{{object.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Base Object</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
            <div v-if="selectedEvent.type==='action' && selectedEvent.baseObj" class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--6-col">
              <select :class="{'is-none':selectedEvent.targetObj===''}" class="mdl-selectfield__select" id="objectType" name="objectType" @change="changeTargetObj">
                <option v-for="(object, objectKey) in getObjects" :class="{'is-none':objectKey===''}" :value="objectKey" :selected="selectedEvent.targetObj===objectKey">{{object.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Target Object (optional)</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
            <div v-if="selectedEvent.type==='action' && selectedEvent.baseObj" class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col">
              <select :class="{'is-none':selectedEvent.resultInventoryObj===''}" class="mdl-selectfield__select" id="objectType" name="objectType" @change="changeResultInventoryObj">
                <option v-for="(object, objectKey) in getObjects" :class="{'is-none':objectKey===''}" :value="objectKey" :selected="selectedEvent.resultInventoryObj===objectKey">{{object.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Result Inventory Object (optional)</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
            <div v-if="selectedEvent.type==='action' && selectedEvent.baseObj" class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col">
              <select :class="{'is-none':selectedEvent.resultStageObj===''}" class="mdl-selectfield__select" id="objectType" name="objectType" @change="changeResultStageObj">
                <option v-for="(object, objectKey) in getObjects" :class="{'is-none':objectKey===''}" :value="objectKey" :selected="selectedEvent.resultStageObj===objectKey">{{object.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Result Stage Object (optional)</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
            <div class="mdl-cell--12-col" style="margin-top: 10px;">
              <router-link style="margin: 5px;" v-if="selectedEvent.type==='group'" :to="('/editor/'+adventureId+'/chapters/'+chapterId+'/timeline/'+selectedEventId)" 
                class="mdl-cell--6-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                  <i class="material-icons" >device_hub</i> Events</router-link>
              <button style="margin: 5px;" @click="removeEvent(selectedEventId)" class="mdl-cell--6-col mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect">
                  Remove</button>
            </div>
          </div>
          <div v-show="!selectedEventId">
            No event selected.
          </div>
        </div>
      </div>        
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable'
  import Breadcrumbs from './Breadcrumbs.vue'
  import DropzoneFirebase from './DropzoneFirebase.vue'
  import TextTools from './TextTools.js'

  Vue.use(Sortable)
  var sectionTimeline

  function removeTimelinePlaceholders(){
    var placeholders = document.getElementsByClassName('event-node-placeholder');
    for(var i=0; i<placeholders.length; i++){
      placeholders[i].parentNode.removeChild(placeholders[i]);
    }
  }
  function addTimelinePlaceholder(dropzone){
    var para = document.createElement("DIV");
    para.className = "event-node-placeholder";
    var t = document.createTextNode("DROP HERE");      // Create a text node
    para.appendChild(t);          // Append the text to <p>
    dropzone.insertBefore(para, dropzone.childNodes[dropzone.childNodes.length-1]); // Append before the PLUS BUTTON
  }
  function getNextDiv(node){
    var nextSibling = node.nextSibling; //get next collapsed
    while(nextSibling && nextSibling.nodeName!=="DIV" && nextSibling.nextSibling){nextSibling=nextSibling.nextSibling};
    return nextSibling;
  }
  function getPrevDiv(node){
    var previousSibling = node.previousSibling; //get next collapsed
    while(previousSibling && previousSibling.nodeName!=="DIV" && previousSibling.previousSibling){previousSibling=previousSibling.previousSibling};
    return previousSibling;
  }

  export default{
    components: {
      Breadcrumbs,
      DropzoneFirebase
    },
    computed: {
      getObjects(){
        var copy = Object.assign({'': {key: '', name: 'none', bg: ''}}, this.chapter.objects);
        return copy;
      }
    },
    data: ()=>({
      adventure: {
        name: "", 
        description: "",
        chapters: {}},
      adventureId: "",
      chapterId: "",
      chapter: {
        name: "", 
        description: ""},
      selectedEventId: "",
      selectedEvent: {},
      advRef: {},
      originalTarget: {},
      timelineLocation: '',
      eventGroupsRef: {},
      eventGroups: [
      ]
    }),
    watch: {
      '$route' (to, from) {
        // react to route changes...
        this.timelineLocation = this.$route.params.group || '';
        this.removeSelection();
      },
      'eventGroups' (to, from) {
        //update eventGroups on firebase
        this.eventGroupsRef.set(to);
      }
    },
    mounted() {
      //This will be used for dropped objects
      interact('.event-node').unset();
      interact('.event-node').
        draggable({
          onstart: function (event) {
            // add active dropzone feedback
            var target = event.target;
            sectionTimeline.originalTarget = target.parentNode;            
            var viewportOffset = target.getBoundingClientRect();
            var timelineContainer = document.getElementById('timeline-container');
            var viewportContainerOffset = timelineContainer.getBoundingClientRect();
            var x = (parseFloat(target.getAttribute('data-x'))||0) + viewportOffset.left - viewportContainerOffset.left;
            var y = (parseFloat(target.getAttribute('data-y'))||0) + viewportOffset.top - viewportContainerOffset.top;
            timelineContainer.appendChild(target);
            target.classList.add('drag-active');            
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
          },
          onend(event){
            var target = event.target;
            //on drop, move event
            target.style.webkitTransform = target.style.transform = 'translate( 0px, 0px)';
            target.setAttribute('data-y', 0);
            target.setAttribute('data-x', 0);
            target.style.transition = "transform 0.33s";
            setTimeout(function(){ target.style.transition = "transform 0s"; }, 330);
            event.target.classList.remove('drag-active');
          },
          onmove(event) {

            var target = event.target;

            var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
      
            // translate the element
            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      
            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          },
          restrict: {
            elementRect: { left: 0, right: 1, top: 0, bottom: 1 }
          }
        }
      )
      .on('tap', function (event) {
         var eventId = event.target.getAttribute('name');
          sectionTimeline.selectEvent(eventId);
      });

    interact('.event-drop-area').unset();
    interact('.event-drop-area').dropzone({
      accept: '.event-node',
      // Require a 75% element overlap for a drop to be possible
      overlap: 0.25,

      // listen for drop related events:

      ondropactivate: function (event) {
        // add active dropzone feedback
        event.target.classList.add('drop-active');
      },
      ondragenter: function (event) {
        var draggableElement = event.relatedTarget,
            dropzoneElement = event.target;

        // feedback the possibility of a drop
        dropzoneElement.classList.add('drop-target');
        draggableElement.classList.add('can-drop');
      },
      ondragleave: function (event) {
        // remove the drop feedback style
        event.target.classList.remove('drop-target');
        event.relatedTarget.classList.remove('can-drop');
        removeTimelinePlaceholders();
      },
      ondrop: function (event) {
        var target = event.target;
        if(target.classList.contains('collapsed')){
          var groupId = target.getAttribute('name');
          var eventId = event.relatedTarget.getAttribute('name');
          var newGroupId = sectionTimeline.createEventGroup(groupId);
          sectionTimeline.moveEventToGroup(eventId, newGroupId);
        }
        else{
          var groupId = target.getAttribute('name');
          var eventId = event.relatedTarget.getAttribute('name');
          sectionTimeline.moveEventToGroup(eventId, groupId);
        }
        // target.insertBefore(event.relatedTarget, target.childNodes[target.childNodes.length-1]);
        sectionTimeline.removeEmptyGroups();
      },
      ondropdeactivate: function (event) {
        // remove active dropzone feedback
        event.target.classList.remove('drop-active');
        event.target.classList.remove('drop-target');
        removeTimelinePlaceholders();
        if(event.relatedTarget.parentElement.id==='timeline-container'){
          sectionTimeline.originalTarget.insertBefore(event.relatedTarget, sectionTimeline.originalTarget.childNodes[sectionTimeline.originalTarget.childNodes.length-1]);
        }
      }
      })      
      .on('dragenter', function (event) {
        // var dropRect = interact.getElementRect(event.target),
        //     dropCenter = {
        //       x: dropRect.left + dropRect.width  / 2,
        //       y: dropRect.top  + dropRect.height / 2
        //     };
        // event.draggable.snap({
        //   anchors: [ dropCenter ]
        // });
        if(!event.target.classList.contains('collapsed'))
        addTimelinePlaceholder(event.target);
      })
      .on('dragleave', function (event) {
        // event.draggable.snap(false);
      });
    
    
    
    

    
    componentHandler.upgradeDom();
    },
    created() {
      sectionTimeline = this;
      this.adventureId = this.$route.params.adventure;
      this.chapterId = this.$route.params.chapter;
      this.timelineLocation = this.$route.params.group || '';
      this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
      this.advRef.on('value', function(snapshot) {
        sectionTimeline.adventure = snapshot.val();
        sectionTimeline.chapter = sectionTimeline.adventure.chapters[sectionTimeline.chapterId];
        sectionTimeline.eventGroups = sectionTimeline.chapter.eventGroups || [];
        sectionTimeline.eventGroupsRef = window.firebase.database().ref('adventures/'+sectionTimeline.adventureId+'/chapters/'+sectionTimeline.chapterId+'/eventGroups');
        sectionTimeline.removeEmptyGroups();
      });
    },
    methods: {
      getActionText(){
        if(TextTools)
        return TextTools.getActionText(this.selectedEvent, this.chapter.objects);
      },
      getGroupIndex(groupId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.key===groupId){
            return groupIndex;
          }
        }
      },
      getGroupByEventId(eventId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          var events = group.events;
          for(var eventIndex in events){
            if(events[eventIndex].key===eventId)
            return group;
          }
        }
      },
      getEventByEventId(eventId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          var events = group.events;
          for(var eventIndex in events){
            if(events[eventIndex].key===eventId)
            return events[eventIndex];
          }
        }
      },
      getLocationName(){
        var locationEvent = this.getEventByEventId(this.timelineLocation);
        if(locationEvent) return locationEvent.name;
        return false;
      },
      getLocationParent(){
        var locationEvent = this.getEventByEventId(this.timelineLocation);
        if(locationEvent && locationEvent.parent) return locationEvent.parent;
        return '';
      },
      moveEventToGroup(eventId, groupId){
        var oldGroup = this.getGroupByEventId(eventId);
        var groupIndex = this.getGroupIndex(groupId);
        for(var eventIndex in oldGroup.events){
          if(oldGroup.events[eventIndex].key === eventId){
            var event = oldGroup.events[eventIndex];
            oldGroup.events.splice(oldGroup.events.indexOf(event), 1);
            this.eventGroups[groupIndex].events.push(event);
          }
        }
      },
      removeSelection(){
        this.selectedEventId = '';
        this.selectedEvent = {};
      },
      removeGroup(groupId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.key===groupId){
            this.eventGroups.splice(this.eventGroups.indexOf(group), 1);
          }
        }
      },
      removeEvent(eventId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.parent===this.timelineLocation){
            for(var eventIndex in group.events){
              var event = group.events[eventIndex];
              if(event.key===eventId){
                group.events.splice(group.events.indexOf(event), 1);
                if(event.type === 'group') this.removeNestedGroups(event.key);
                this.removeEmptyGroups();
              }
            }
          }
        }
        this.removeSelection();  
      },
      removeNestedGroups(eventId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.parent === eventId){
            this.eventGroups.splice(groupIndex, 1);
          }
        }
      },
      removeEmptyGroups(){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(!group.events || group.events.length<=0){
            this.eventGroups.splice(groupIndex, 1);
          }
        }
      },
      createEvent(groupId){
        var eventKey= 'event'+Date.now();
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.key === groupId){
            group.events.push(
              {
                key: eventKey,
                type: 'action',
                name: 'event',
                customText: false,
                text: ''
              }
            );
          }
        }
        this.selectEvent(eventKey);
        return eventKey;
      },
      createEventAndGroup(groupId){
        var eventKey= 'event'+Date.now();
        var newGroupId = this.createEventGroup(groupId);
        var groupIndex = this.getGroupIndex(newGroupId);
        this.eventGroups[groupIndex].events.push(
          {
            key: eventKey,
            type: 'action',
            name: 'event',
            customText: false,
            text: ''
          }
        );
        this.selectEvent(eventKey);
        return eventKey;
      },
      createEventGroup(groupId){
        var newGroupIdNumber = this.eventGroups.length;
        var newGroupId= 'group'+Date.now();
        if(typeof(groupId)==='string'){
          var groupIndex = this.getGroupIndex(groupId);
          this.eventGroups.splice(groupIndex, 0,
            {
              key: newGroupId,
              parent: this.timelineLocation,
              events: []
            }
          );
          return newGroupId;
        }
        else{
          this.eventGroups.push(
            {
              key: newGroupId,
              parent: this.timelineLocation,
              events: []
            }
          )
          return newGroupId;
        }
      },
      eventGroupsForLocation(timelineLocation){
        return this.eventGroups.filter(function (group) {
          return group.parent === timelineLocation
        })
      },
      selectionClass(eventId, selectedEventId){
        return eventId === this.selectedEventId ? "selected" : ""
      },
      selectEvent(eventId){
        this.selectedEventId = eventId;
        this.selectedEvent = this.getEvent(this.selectedEventId);
      },
      changeEventName(e){
        var newValue = event.target.value;
        this.selectedEvent.name = newValue;
        this.updateSelectedEvent(); 
      },
      changeEventCustomText(e){
        this.selectedEvent.customText = !this.selectedEvent.customText;
        this.updateSelectedEvent(); 
      },
      changeEventText(e){
        var newValue = event.target.value;
        this.selectedEvent.text = newValue;
        this.updateSelectedEvent(); 
      },
      changeEventType(e){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.selectedEvent.type = newValue;
        this.updateSelectedEvent();
      },
      changeBaseObj(e){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.selectedEvent.baseObj = newValue;
        this.updateSelectedEvent();
      },
      changeTargetObj(e){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.selectedEvent.targetObj = newValue;
        this.updateSelectedEvent();
      },
      changeResultInventoryObj(e){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.selectedEvent.resultInventoryObj = newValue;
        this.updateSelectedEvent();
      },
      changeResultStageObj(e){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.selectedEvent.resultStageObj = newValue;
        this.updateSelectedEvent();
      },
      updateSelectedEvent(){
        var currentGroup = this.getGroupByEventId(this.selectedEventId);
        var groupIndex = this.getGroupIndex(currentGroup.key);
        var eventIndex = this.getEventIndex(this.selectedEventId, currentGroup);
        this.eventGroupsRef.child(groupIndex+'/events/'+eventIndex).set(this.selectedEvent);
      },
      getEventIndex(eventId, group){
        for(var eventIndex in group.events){
          if(group.events[eventIndex].key === eventId)
          return eventIndex
        }
        return -1;
      },
      getEvent(eventId){
        for(var groupIndex in this.eventGroups){
          var group = this.eventGroups[groupIndex];
          if(group.parent===this.timelineLocation){
            for(var eventIndex in group.events){
              var event = group.events[eventIndex];
              if(event.key===eventId){
                return event;
              }
            }
          }
        }
        return null;
      }
    }
  }

</script>
<style>

  .timeline-container{
    position: relative;
    width: 100%;
    text-align:center;
    display: block;
    overflow: hidden;
    margin-bottom: 100px;
  }

  .arrow-up {
    display: block;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #BBBBBB;
    margin-top: 0px;
    margin-bottom: -10px;
    margin-left: auto;
    margin-right: auto;
    padding-left: -20px;
  }

  .arrow-down {
    display: block;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid #BBBBBB;
    margin-top: -10px;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    padding-left: -20px;
    padding-top: -20px;
  }

  .arrow-up.delimiter{
    border-bottom: 20px solid #556E7B;
  }

  .arrow-down.delimiter{
    border-top: 20px solid #556E7B;
  }

  .timeline-container a, .timeline-container a:hover, .timeline-container a:visited, .timeline-container a:active{
    text-decoration: none;
  }

  .delimiter-node{
    margin-left: auto;
    margin-right: auto;
    background-color: #556E7B;
    color: #ffffff;
    height: 35px;
    font-size: 20px;
    padding: 15px 5px 35px 5px;
    width: 180px;
    display: block;
    border-radius: 5px;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-node{
    background-color: #3f51b5;
    color: #ffffff;
    height: 30px;
    font-size: 20px;
    padding: 5px;
    margin: 5px;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    vertical-align: middle;    
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-node.selected{
    background-color: #418DDF;
    border: solid 2px #fff;
    padding-top: 3px;
  }

  .event-node-placeholder{
    background-color: #909090;
    border: dashed 3px #aaaaaa;
    color: #cfcfcf;
    height: 30px;
    font-size: 12px;
    padding: 3px 5px 3px 5px;
    margin: 5px;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    vertical-align: middle;
  }

  .event-node:hover{
    background-color: #0066CC;   
  }

  .event-node.drag-active{
    position: absolute;
    top: 0;
    left: 0;
  }

  .group-node{
      transition: height ease-in-out 400ms;
  }

  .group-node:hover{
      /*height: 10px;*/
    background-color: rgba(0, 0, 0, 0.05);
  }

  .group-node.drop-target{
    background-color: rgba(0, 0, 255, 0.05);
  }

  .event-group-node{
    background-color: #BBBBBB;
    margin: 5px;
    padding: 5px;
    display: inline-block;
    border-radius: 5px;
    min-width: 100px;
  }


  .plus-button {
    width: calc(100% - 10px);
    margin: 3px;
    height: 20px;
    border-radius: 10px;
    background-color: #888888;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 20px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    -webkit-transition: font-size 0.25s, border-radius 0.25s, width 0.25s, height 0.25s, background-color 0.25s, -webkit-transform 1s;
    transition: font-size 0.25s, border-radius 0.25s, width 0.25s, height 0.25s, background-color 0.25s, padding 0.25s, transform 1s;
  }
  .group-node.drop-target .plus-button, .group-node:hover .plus-button {
    height: 30px;
    width: calc(100% - 10px);
    border-radius: 20px;
    font-size: 30px;
    padding-top: 5px;
  }
  .plus-button:hover {
    background-color: #0066CC;
  }

  .group-node.collapsed .plus-button{
    width: 20px;
  }

  .group-node.collapsed.drop-target .plus-button, .group-node.collapsed:hover .plus-button {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    padding-top: 10px;
  }

  .mdl-selectfield select.is-none{
    color: #aaa; 
  }
  .mdl-selectfield select.is-none option{
    color: rgb(44, 62, 80);
  }
  .mdl-selectfield select.is-none option.is-none, .mdl-selectfield option.is-none{
    color: #aaa; 
  }

</style>



// WEBPACK FOOTER //
// SectionTimeline.vue?32a62dd8